import useIsHomepage from 'home/hooks/isHomepage'
import useIsSearchPage from 'hooks/Navigation/useIsSearchPage'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import { useMemo } from 'react'
import { useLocation } from 'react-router'

/**
 * Whether the mobile util bar shows the search icon button (vs a search field elsewhere).
 * Mirrors NavBarSearchButton visibility — homepage uses UtilSearchBar below the util row.
 */
function useNavBarShowsMobileSearchIcon(): boolean {
  const isHomepage = useIsHomepage()
  const isSearchPage = useIsSearchPage()
  const location = useLocation()

  return useMemo(() => {
    if (isHomepage) {
      return false
    }

    if (isSearchPage) {
      return !!matchLocaleAwarePath(location.pathname, { path: '/:regionCode/search/shop' })
    }

    return true
  }, [isHomepage, isSearchPage, location.pathname])
}

export default useNavBarShowsMobileSearchIcon
